module.exports = __webpack_public_path__ + "static/media/pin_me.a0bdfb91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_me.svg
// module id = 900
// module chunks = 0